import { Tower } from './Tower';
import { Monster } from '../monsters/Monster';

export class PiercingTower extends Tower {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    // damage: 30, attackSpeed: 1.2, range: 160 - bullets pierce through enemies
    super(scene, x, y, 30, 1.2, 160);
    
    // Set high pierce count by default
    this.pierceCount = 3;
    
    this.removeAll();
    this.createPiercingVisuals();
  }

  protected override createVisuals(): void {
    // Create piercing tower base
    const base = this.scene.add.circle(0, 0, 20, 0x666600);
    this.add(base);
    
    // Create rail gun style cannon
    const barrel = this.scene.add.rectangle(0, -18, 8, 30, 0xaaaa00);
    this.add(barrel);
    
    // Add energy core
    const core = this.scene.add.circle(0, 0, 8, 0xffff00, 0.7);
    this.add(core);
    
    // Add piercing indicator
    const indicator = this.scene.add.circle(0, -30, 4, 0x00ffff);
    this.add(indicator);
  }

  private createPiercingVisuals(): void {
    this.createVisuals();
  }

  protected override fireProjectile(target: Monster, damage: number, isCrit: boolean): void {
    // Create piercing projectile
    const projectile = this.scene.add.rectangle(this.x, this.y, 4, 12, isCrit ? 0xff0000 : 0xffff00);
    
    // Calculate extended target for piercing effect
    const angle = Phaser.Math.Angle.Between(this.x, this.y, target.x, target.y);
    const extendedX = this.x + Math.cos(angle) * this.effectiveRange;
    const extendedY = this.y + Math.sin(angle) * this.effectiveRange;
    
    this.scene.tweens.add({
      targets: projectile,
      x: extendedX,
      y: extendedY,
      duration: 250,
      ease: 'Linear',
      onComplete: () => {
        // Use the base class piercing damage system
        this.applyPiercingDamage(target, damage, this.pierceCount);
        
        if (isCrit) {
          this.showCritEffect(target.x, target.y);
        }
        
        projectile.destroy();
      }
    });
  }
} 